<template>
    <v-card class="wost-expanded-content" :elevation="5">
        <v-card-text class="wost-customer-detail">                                           
            <v-container fluid>
                <v-row>
                    <v-col cols="8">
                        <v-card>
                            <v-card-text class="padding-bootom-0">
                                <span>Ordenes</span>
                            </v-card-text>
                            <v-card-text class="padding-top-0">
                                <v-simple-table height="162px" class="wost-table-detail">
                                    <tbody>
                                        <tr v-for="order in orders" :key="order.id">
                                            <td>{{ order.id | number-order }}</td>
                                            <td>{{ order.total | currency('S/') }}</td>
                                            <td>{{ order.entry_time | moment("MMM DD, YYYY") }}</td>
                                            <td><span :class="order.status.toLowerCase()">{{ order.status }}</span></td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="4">
                        <v-card>
                            <v-card-text class="padding-all-5">
                                <ul class="detail-card-header">
                                    <li>
                                        <span v-if="customer.type_document == 'DNI'" class="detail-title-cliente">
                                            {{ customer.name.toUpperCase() + ' ' + customer.surname.toUpperCase()}}
                                        </span>
                                        <span v-else class="detail-title-cliente">{{ customer.name.toUpperCase() }}</span>
                                    </li>                                                                        
                                    <li><span :class="'status-' + customer.status.toLowerCase() + ' detail-card-status'">{{ customer.status }}</span></li>
                                </ul>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-text class="padding-all-5">
                                <ul class="wost-customer-detail-data">
                                    <li>
                                        <i class="fas fa-address-card"></i><span>{{ customer.document }}</span>
                                    </li>
                                    <li>
                                        <i class="fas fa-home"></i><span>{{ customer.address }}</span>
                                    </li>
                                    <li>
                                        <i class="fas fa-phone-square-alt"></i><span>{{ customer.phone }}</span>
                                    </li>
                                    <li>
                                        <i class="fas fa-envelope"></i><span style="text-transform: lowercase !important;">{{ customer.email }}</span>
                                    </li>
                                </ul>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-text class="padding-all-5">
                                <ul class="wost-customer-detail-data">
                                    <li>
                                        <strong>Crédito </strong><span class="text-green">{{ customer.credit_line | currency('S/') }}</span>
                                    </li>
                                    <li>
                                        <strong>Descuento </strong><span class="text-red">{{ customer.discount | currency('S/') }}</span>
                                    </li>
                                </ul>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'CustomerDetail',
    props: ['customer', 'orders']    
}
</script>

<style>

</style>